import type { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

export const useSelectFilterStyles = makeStyles((theme: Theme) =>
    createStyles({
        marginX: {
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
        },
        marginY: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        input: {
            fontSize: 12,
        },
        select: {
            "&:focus": {
                backgroundColor: "transparent",
            },
        },
        itemText: {
            fontSize: 12,
        },
        checkbox: {
            width: 8,
            height: 8,
        },
        menu: {
            maxHeight: 25,
        },
    })
);
